export default class{
    static getSeriesColors(){
        return [
            "#e83e3b",
            "#fdb827",
            "#2d9bb1",
            "#95C36C",
            "#5a86fe",
            "#320065",
            "#e80f9f",

            "#F37B31",
            "#7c5e81",
            "#C9D74A",
            "#78A5B5",
            "#4643B2",
            "#8D0882",
            "#E8276D",
            
            "#ac3c29",
            "#e6b024",
            "#d7d02f",
            "#7fa978",
            "#4c66d1",
            "#3b0351",
            "#940f5b",
            
            "#826251",
            "#35543F",
            "#cee2a8",
            "#aac2f1",
            "#937fb9",
            "#d84fb1",
            "#664a3b",
            
            "#EF6734",
            "#FDC927",
            "#DADE3E",
            "#81AF9D",
            "#4D59CB",
            "#6F0578",
            "#E81F7E",
            
            "#f69941",
            "#816A5E",
            "#cbdc83",
            "#95b5da",
            "#7366b4",
            "#b22096",
            "#f07a97",
        ];
    }

    //Returns undefined if no color is specified for this point name
    static getColorForPoint(pointName){
        if(pointName.indexOf("Ambient.Temperature") !== -1){
            return "#3c9946";
        }else if(pointName.indexOf("Upper Limit") !== -1 || pointName.indexOf("Lower Limit") !== -1){
            return "#38425e";
        }
        return undefined;
    }
}


// WEBPACK FOOTER //
// ./src/utils/seriesColor.js